import type { ChildrenProps } from "../types";
import { StatsLabel } from "./stats-label";
import { StatsContainer } from "./stats-line";
import { StatsValue } from "./stats-value";

/** Props Interface */
interface StatsProps extends ChildrenProps {}

export function Stats({ children }: StatsProps) {
	return (
		<div
			className="flex flex-col"
			style={{
				flex: 1,
				minWidth: "max-content",
			}}
		>
			{children}
		</div>
	);
}

Stats.Container = StatsContainer;

Stats.Label = StatsLabel;

Stats.Value = StatsValue;
